import React, { Component } from 'react';
import { Fragment } from 'react';
import { default as MCheckbox } from 'material-ui/Checkbox';
import { isEmpty } from 'lodash';

export default class SelectableList extends Component {
  state = {
    selectedItems: [],
  };

  componentDidMount() {
    // If has no intially selected items
    if (isEmpty(this.props.initialSelectedItems)) return;

    // If state already has selectedItems
    if (!isEmpty(this.state.selectedItems)) return;

    const selectedItems = [];
    const { items } = this.props;
    for (let i = 0; i < items.length; i++) {
      console.log(items[i].soundcastId, this.props.initialSelectedItems, 'initialSelectedItems');
      if (~this.props.initialSelectedItems.indexOf(items[i].soundcastId))
        selectedItems.push(items[i].soundcastId);
    }
    this.setState({
      selectedItems,
    });
    this.props.onChange(selectedItems);
  }

  handleSelectAll = () => {
    const { items } = this.props;
    const { selectedItems } = this.state;
    // If already selected all then deselect all
    if (items.length === selectedItems.length) {
      this.setState(
        {
          selectedItems: [],
        },
        () => {
          this.props.onChange(this.state.selectedItems);
        }
      );
      return;
    }
    const soundcastIds = items.map(soundcast => soundcast.soundcastId);
    this.setState(
      {
        selectedItems: soundcastIds,
      },
      () => {
        this.props.onChange(this.state.selectedItems);
      }
    );
  };

  handleSelect = soundcastId => e => {
    const index = this.state.selectedItems.indexOf(soundcastId);
    const selectedItems = [...this.state.selectedItems];
    if (~index) {
      selectedItems.splice(index, 1);
    } else {
      selectedItems.push(soundcastId);
    }
    this.setState({ selectedItems }, () => {
      this.props.onChange(this.state.selectedItems);
    });
  };

  render() {
    const { label, items } = this.props;
    return (
      <Fragment>
        <div className="field-title">{label}</div>
        <div className="categorySelector">
          <div className="selectorHead">
            <div className="checkbox-entry">
              <MCheckbox
                checked={items.length === this.state.selectedItems.length}
                label="Select All"
                labelStyle={{
                  fontSize: '1.6rem',
                  fontWeight: 'normal',
                }}
                iconStyle={{
                  width: 25,
                  height: 25,
                  fill: '#ff8f53',
                }}
                onClick={this.handleSelectAll}
              />
            </div>
          </div>
          <div className="selectorBody">
            {items.map(soundcast => (
              <div className="selectorRow" key={soundcast.soundcastId}>
                <div className="checkbox-entry">
                  <MCheckbox
                    checked={!!~this.state.selectedItems.indexOf(soundcast.soundcastId)}
                    label={soundcast.title}
                    labelStyle={{
                      fontSize: '1.6rem',
                      fontWeight: 'normal',
                    }}
                    iconStyle={{
                      width: 25,
                      height: 25,
                      fill: '#ff8f53',
                    }}
                    onClick={this.handleSelect(soundcast.soundcastId)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Fragment>
    );
  }
}
